import Header from "./components/Header";
import Nav from "./components/Nav";
import About from "./components/About";
import Experience from "./components/Experience";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
// import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import AnimationToScroll from "./components/AnimationToScroll";

const App = () => {
  return (
    <>
      <AnimationToScroll />
      <Header />
      <Nav />
      <About />
      <Experience />
      <Services />
      <Portfolio />
      {/* <Testimonials /> */}
      <Contact />
      <Footer />
    </>
  );
};

export default App;

//Lien du cours https://www.youtube.com/watch?v=G-Cr00UYokU&t=514s 1h11m
